import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBF3w-ZRFalL9khOZIZ4uUFmmncB1s15vU",
  authDomain: "twitter-clone-9c47a.firebaseapp.com",
  databaseURL: "https://twitter-clone-9c47a.firebaseio.com",
  projectId: "twitter-clone-9c47a",
  storageBucket: "twitter-clone-9c47a.appspot.com",
  messagingSenderId: "908487606022",
  appId: "1:908487606022:web:c5a9c995a3a4d27c986887",
  measurementId: "G-4NY19JN107",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
